<template>
<div class="add-client-vue">
    
    <!-- Main Body Content area -->
    <div class="o-main-content-area o-main-content-area--padBotoomNone">
        <div class="row c-responsive-fixwidth">
            <div class="col-md-6">
                <h1 class="h1">Report List:</h1>
            </div>
            <div class="col-md-6 text-right">
                <ul class="o-filter-area">
                    <li><a @click="addNewRow()" href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-plus" aria-hidden="true"></i> Add </a></li>
                    <!-- <li><a href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save" aria-hidden="true"></i> Save</a></li> -->
                </ul>
            </div>
        </div>
        <div class="field-group" v-for="(report, index) in reportList" :key="index">
            <div class="row">
                <div class="col-sm-12">
                    <div class="c-common-space c-common-box-shadow c-radius3">
                        <div class="c-user-tab-content clearfix o-skillset-area">
                            <p>Report #{{index+1}}:</p>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group ">
                                        <label class="common-label-text form-label">Report Label:</label>
                                        <input type="Label" v-model="report.label" v-validate="{ required: true}" name="label" class="form-control" placeholder="Report Label" data-vv-delay="500">      
                                        <span v-show="errors.has('label') && validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group ">
                                        <label class="common-label-text  form-label">JSON URL:</label>
                                        <input  v-model="report.json_array" v-validate="{ required: true}" name="url" type="text" class="form-control" placeholder="JSON URL">
                                        <span v-show="errors.has('url') && validation_err!=0" class="err-msg">{{ errors.first('url') }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <!-- <div class="form-group ">
                                        <label class="common-label-text">API URL:</label>
                                        <input type="text" v-model="report.api" v-validate="{ required: true}" name="api" class="form-control" placeholder="API URL">
                                        <span v-show="errors.has('api') && validation_err!=0" class="err-msg">{{ errors.first('api') }}</span>
                                    </div> -->
                                    <div class="form-group ">
                                        <label class="common-label-text">Report Type:</label>
                                        <div class="o-cutsomSelect">
                                            <select placeholder="Report Type" v-model="report.type" v-validate="{ required: true}" name="type">
                                                <option value="monthly">Monthly</option>
                                                <option value="yearly">Yearly</option>
                                                <option value="custom">Custom Date</option>
                                                <option value="hourly">Total Hours</option>
                                                <option value="employee">Employee</option>
                                                <option value="call_action">Call Action</option>
                                                <option value="daily_schedule">Daily Schedule</option>
                                                <option value="null">NULL</option>
                                            </select>
                                            <span v-show="errors.has('tupe') && validation_err!=0" class="err-msg">{{ errors.first('type') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group ">
                                        <label class="common-label-text">User Access:</label>
                                        <div class="o-cutsomSelect">
                                            <select placeholder="User Access" v-model="report.role_id" v-validate="{ required: true}" name="role">
                                                <option value="">Select User Access</option>
                                                <option v-for="(role, key) in roles" :value="role.id" :key="key" v-if="role.name !== 'User'"> {{role.name}} </option>
                                            </select>
                                            <span v-show="errors.has('role') && validation_err!=0" class="err-msg">{{ errors.first('role') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <label class="common-label-text form-label">Report RDLX:</label>
                                        <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{new_files[0].selected?'Change Files':'Add New Files'}}</button>
                                            <input type="file" @change="addFileForAddNewJob($event,0)" :id="report.id" />
                                            <!-- <button @click="uploadService()" v-if="new_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button> -->
                                            <a :href="report.rdlx_template" v-if="report.rdlx_template" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(new_files[0].name)}}</span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-3  text-right">
                                    <ul class="o-filter-area">
                                        <li v-if="report.status!='new'">
                                            <a @click="deleteRow(index)" href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--red"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a>
                                        </li>
                                        <li v-if="report.status!='new'">
                                            <!-- <a @click="editRow(index)" href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-pencil" aria-hidden="true"></i> Update </a> -->
                                            <a @click="updateRow(index)" href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-pencil" aria-hidden="true"></i> Update </a>
                                        </li>
                                        <li v-if="report.status=='new'">
                                            <a @click="saveRow(index)" href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save" aria-hidden="true"></i> Save</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Main Body Content area -->
</div>

</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userID: 'userID'
            })
        },
        data() {
            return {
                data:'',
                validation_err:0,
                reportList:[],
                roles:[],
                reportItem:{
                    label:'',
                    api:'',
                    json_array:'',
                    role_id:'',
                    rdlx_template:'',    
                    id:'',
                    type:'',
                    status:'new',
                    file_name:'',
                    image_file:''
                },
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
            }
        },
        created() {
            if(!this.reportList.length){
                this.reportList.push(this.reportItem);
            }
            this.getReportList();
            this.getRoles();
        },
        methods: {
            saveRow(index){
                this.loading = true;
                let temp = this.reportList[index];
                if(!temp.label){
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please enter a label.'
                    });
                    return;
                }else if(this.new_files[0].name=="No file chosen"){
                    // this.$notify.error({
                    //     title: this.$t('error'),
                    //     message: 'Select a template.'
                    // });
                    // return;
                    temp['file_name'] = '';
                    temp['image_file'] = '';
                }else{
                    temp.image_file = this.new_files[0].img;
                    temp.file_name = this.new_files[0].name;
                }
                service.post('superadmin/saveActiveReportRow', temp , {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    this.loading = false;
                    this.new_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: this.$t('success'),
                        message: 'Saved successfully.'
                    });
                    this.getReportList();
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                });
            },
            deleteRow(index){
                 this.loading = true;
                 let temp = this.reportList[index];
                 service.del('superadmin/deleteActiveReportRow/'+temp.id, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    this.loading = false;
                    this.new_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: this.$t('success'),
                        message: 'Deleted successfully.'
                    });
                    this.getReportList();
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                });
            },
            updateRow(index){
                this.loading = true;
                let temp = this.reportList[index];
                if(!temp.label){
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please enter a label.'
                    });
                    return;
                }
                if(this.new_files[0].name=="No file chosen"){
                    temp['file_name'] = '';
                    temp['image_file'] = '';
                    // this.$notify.error({
                    //     title: this.$t('error'),
                    //     message: 'Select a image file.'
                    // });
                    // return;
                }else{
                    temp.image_file = this.new_files[0].img;
                    temp.file_name = this.new_files[0].name;
                }
                service.put('superadmin/updateActiveReportRow/'+temp.id, temp , {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    this.loading = false;
                    this.new_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: this.$t('success'),
                        message: 'Updated successfully.'
                    });
                    this.getReportList();
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                });
            },
            addFileForAddNewJob(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                        
                        //console.log( this.new_files, index);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },
            snippet(value) {
                if (value.length > 25)
                    return value.slice(0, 25) + '  ...';
                else
                    return value;
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            addNewRow(){
                this.reportList.push(this.reportItem);    
            },
            
            addFileForAddNewJob(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                        
                        //console.log( this.new_files, index);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },
            
            snippet(value) {
                if (value.length > 15)
                    return value.slice(0, 7) + '...';
                else
                    return value;
            },
           
            uploadService(){

            },

            getReportList(){
                service.get('superadmin/getAllActiveReports', {
                    'Authorization': this.userToken,
                }).then((res) => {
                    // console.log(res);
                    let results = res.data.result;
                    this.reportList=[];
                    results.forEach(item => {
                        item['status'] = '';
                        item['file_name'] = '';
                        item['image_file'] = '';
                        this.reportList.push(item);
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },

            getRoles(){
                service.get('reports/getRoles', {
                    'Authorization': this.userToken
                }).then((res) => {
                    // console.log('reports/getRoles', res);
                    this.roles=res.data.result;
                   
                }).catch((err) => {
                    console.log(err);
                });
            }


        }
    }

</script>
<style scoped>
.c-user-tab-content {
    padding: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/reportsConfig/ReportsConfig.vue